import {useEffect, useState} from 'react';
import axios from "axios"
import Nav from "../Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import * as XLSX from "xlsx";
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import L from 'leaflet';
import {MapContainer, TileLayer, Marker, Popup, useMap} from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import '../../App.css';
import {useLocation} from 'react-router-dom'

import icon from 'leaflet/dist/images/marker-icon.png';
import wfo_icon from '../../img/wfo.svg';
import hts_icon from '../../img/hts.svg';
import aud_icon from '../../img/aud.svg';
import ittlp_icon from '../../img/ittlp.svg';
import wtl_icon from '../../img/wtl.svg';
import wtt_icon from '../../img/wtt.svg';
import wtu_icon from '../../img/wtu.svg';
import ittop_icon from '../../img/ittop.svg';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import {Map} from "leaflet/dist/leaflet-src.esm";

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

let wfo = L.icon({
    iconUrl: wfo_icon,
    iconSize: [25, 25]
});
let hts = L.icon({
    iconUrl: hts_icon,
    iconSize: [25, 25]
});
let ittop = L.icon({
    iconUrl: ittop_icon,
    iconSize: [25, 25]
});

let aud = L.icon({
    iconUrl: aud_icon,
    iconSize: [25, 25]
});

let ittlp = L.icon({
    iconUrl: ittlp_icon,
    iconSize: [25, 25]
});
let wtl = L.icon({
    iconUrl: wtl_icon,
    iconSize: [25, 25]
});
let wtt = L.icon({
    iconUrl: wtt_icon,
    iconSize: [25, 25]
});
let wtu = L.icon({
    iconUrl: wtu_icon,
    iconSize: [25, 25]
});

L.Marker.prototype.options.icon = DefaultIcon;

let source = axios.CancelToken.source();
function iniState() {
    return (
        {
            objs: [],
            datas: [],
            objsl: false,
            lat: 9.01552831605,
            lon: 38.7280055719,
            zoom: 13,
            search:'',
            tracking_id:'',
            success:'',
            txt:'',
        }
    )
}
let isload=false;
function Tracking () {
    const [state,setState]=useState(()=>iniState())
    const useQuery= () => {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();
    let tracking_id =query.get('tracking_id');
    if(!isload) {
        let redirecttologin = myconfig.redirecttologin;
        let baseurl = myconfig.tracking;
        axios.post(baseurl, {
            tracking_id: tracking_id,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.success == false) {
                setState(prvstate => {
                    return {
                        ...prvstate,
                        objs: [],
                        success:false,
                        objsl: true,
                        txt:res.data.msg,
                        tracking_id:tracking_id,
                    }
                })
            } else {
                setState(prvstate => {
                    return {
                        ...prvstate,
                        objs: res.data,
                        success:true,
                        txt:'',
                        tracking_id:tracking_id,
                        objsl: true,
                        lat: res.data.data.vec_lat,
                        lon: res.data.data.vec_lon,
                        zoom: 12,
                    }
                })
            }
            isload=true;
        }).catch((e) => {
            console.log(e.message);
        });
    }
    function MyComponent() {
        const map = useMap()
        map.setView(
            [
                state.lat,
                state.lon
            ],
            state.zoom
        )
        return null;
    }
    function display_map() {
        let retdata = <p className="px-2">loading.....</p>
        if(state.objsl) {
            if(state.success) {
                let markerhtc = null;
              /*  let type = "Arrived @ customer";
                if (state.objs.data.type != "WAITING_TO_OFFLOAD") {
                    type = "Heading to customer";
                    markerhtc = <Marker
                        key={1}
                        position={[
                            state.objs.data.cus_lat,
                            state.objs.data.cus_lon,
                        ]}
                        icon={ittop}
                    >
                        <Popup>
                            <div className="card">
                                <div className="card-header">
                                    <h2>{state.objs.data.cus_name}</h2>
                                </div>
                                <div className="card-footer p-0">
                                    <ul className="nav flex-column">
                                        <li className="nav-item">
                                            <a href className="nav-link">{state.objs.data.cus_name}}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </Popup>
                    </Marker>
                }*/

                retdata = <MapContainer center={[state.lat, state.lon]} zoom={state.zoom}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker
                        key={1}
                        position={[
                            state.lat,
                            state.lon,
                        ]}
                        icon={wfo}
                    >
                        <Popup className="popup">
                            <div className="card p-0 m-0" >
                                <div className="card-header">
                                    <h2>{state.objs.data.plate_no}</h2>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Customer : </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.customer}</p>
                                        </div>

                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Cargo : </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.cargo_name}</p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Orgin : </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.org_name}</p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Destination : </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.des_name}</p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold  px-0 py-2 m-0">Truck: </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.plate_no}</p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold  px-0 py-2 m-0">Driver: </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.driver_name}</p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Tracking # : </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.frightno}</p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Current Location: </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.current_loc}</p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Left KM: </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.km}</p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Allocated At: </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.dateofallocation??"NA"}</p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Arrived At Load: </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.dateofarivalatloadpoint??"NA"}</p>
                                        </div>

                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Load At: </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.dateofloading??"NA"}</p>
                                        </div>

                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Departure At: </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.dateofdeparture??"NA"}</p>
                                        </div>

                                        <div className="col-6 p-0 m-0">
                                            <p className="text-bold px-0 py-2 m-0">Arrived At Offload: </p>
                                        </div>
                                        <div className="col-6 p-0 m-0">
                                            <p className="px-0 py-2 m-0">{state.objs.data.dateofarivalatoffloadpoint??"NA"}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer p-0">
                                    <ul className="nav flex-column">
                                        <li className="nav-item">
                                            <a href className="nav-link">{state.objs.data.type}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </Popup>
                    </Marker>
                    {markerhtc}
                    <MyComponent/>
                </MapContainer>
            }
            else
            {
                retdata = <p className="px-2">{state.txt}</p>
            }
        }
        return <>{retdata}</>
    }
    function btn_track(event) {
        event.preventDefault()
        if (state.objsl) {
            if (state.tracking_id == "") {
                Swal.fire({
                    title: 'Error!',
                    text: "Enter the tracking #",
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
            else {
                var ulr = myconfig.redirecttotracking + "?tracking_id=" + state.tracking_id
                window.open(ulr, "_self");
            }
        }
    }
    function txt_track(event) {
        event.preventDefault()
        if (state.objsl) {
            var value = event.target.value;
            setState(prvstate => {
                return {
                    ...prvstate,
                    tracking_id: value,
                }
            })
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-3">
                        <form action="#" onSubmit={btn_track}>
                            <div className="input-group px-2">
                                <input type="text" name="tracking_id" onChange={txt_track} value={state.tracking_id} placeholder="Type tracking # ..." className="form-control" />
                                <span className="input-group-append">
            <button onClick={btn_track} type="button" className="btn btn-primary">Track</button>
          </span>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-12">
                        {display_map()}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Tracking;
